const btohHash = [];
const btohMap = byte =>
  btohHash[byte] ?? (btohHash[byte] = byte.toString(16).padStart(2, '0'));

export const btoh = bytes => [...bytes].map(btohMap).join('');

export const htob = hexString =>
  new Uint8Array(hexString.match(/(..?)/g).map(value => parseInt(value, 16)));

/* Converts a string to a Uint8Array representing UTF-8 encoded text. This function
 * will handle standard characters, extended characters up to 0x800, and surrogate
 * pairs for characters beyond the Basic Multilingual Plane (e.g., emoji, historic
 * scripts, etc.). It covers the full range of characters and ensures proper encoding
 * by checking the character code and applying the appropriate UTF-8 byte sequence.
 */
export const toUint8Array = str => {
  const utf8 = [];
  for (let i = 0; i < str.length; i++) {
    let charcode = str.charCodeAt(i);
    if (charcode < 0x80) utf8.push(charcode);
    else if (charcode < 0x800) {
      utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      utf8.push(
        0xe0 | (charcode >> 12),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      );
    } else {
      // surrogate pair
      // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves
      i++;
      charcode = 0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
      utf8.push(
        0xf0 | (charcode >> 18),
        0x80 | ((charcode >> 12) & 0x3f),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      );
    }
  }
  return new Uint8Array(utf8);
};

export const fromUint8Array = data => {
  let str = '';
  for (let i = 0; i < data.length; i++) {
    const value = data[i];

    if (value < 0x80) {
      str += String.fromCharCode(value);
    } else if (value > 0xbf && value < 0xe0) {
      str += String.fromCharCode(((value & 0x1f) << 6) | (data[++i] & 0x3f));
    } else if (value > 0xdf && value < 0xf0) {
      str += String.fromCharCode(
        ((value & 0x0f) << 12) | ((data[++i] & 0x3f) << 6) | (data[++i] & 0x3f)
      );
    } else {
      const charCode =
        (((value & 0x07) << 18) |
          ((data[++i] & 0x3f) << 12) |
          ((data[++i] & 0x3f) << 6) |
          (data[++i] & 0x3f)) -
        0x010000;
      str += String.fromCharCode((charCode >> 10) | 0xd800, (charCode & 0x03ff) | 0xdc00);
    }
  }
  return str;
};
